import fetchWrapper from '../../../apsisEngine/helpers/fetchWrapper';
import DashboardUnit from "../../../apsisEngine/dashboard/";
import { useEffect, useState } from "react";
import React from "react";
import { swalError, swalSuccess } from "../../helpers/swal";
import { useHistory } from "react-router-dom";
import { Spin } from 'antd';
const Index = () => {
  const [data, setData] = useState([]);
  const [customiseWidgets, setCustomiseWidgets] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [widgetsData, setWidgetsData] = useState([]);
  const [userDashboardData, setUserDashboardData] = useState([]);
  const moduleData = localStorage.getItem("module_info");
  const moduleInfo = JSON.parse(moduleData);
  console.log(moduleInfo);
  const history = useHistory();
  const getAllWidgetData = async () => {
    await fetchWrapper
      .get(`dashboard/widget/22`)
      .then((response) => {
        if (!response.error) {
          setData(response.data);
        } else {
          swalError(response?.message);
        }
         setInitialLoading(false)
      })
      .catch((error) => {
        console.log(error?.message);
        swalError(error?.message.toString());
         setInitialLoading(false)
      });
  };

  const getAllgetSingleUserDataWidgetData = async () => {
    await fetchWrapper
      .get(`dashboard/widget/single-user/${22}`)
      .then((response) => {
        if (!response?.error) {
          setData(response.data);
          setUserDashboardData(response.data);
          const currentWidgets = [];
          for (let i = 0; i < response.data.length; i++) {
            currentWidgets.push({
              dashboard_widget_conf_id: response.data[i].dashboard_widget_conf_id,
              dashboard_widget_id: response.data[i].dashboard_widget_id,
              dnd_layout_config: response.data[i].dnd_layout_config,
            });
          }
          setWidgetsData(currentWidgets);
           setInitialLoading(false)
        } else {
          swalError(response?.message);
          setInitialLoading(false)
          // history.push({
          //   pathname: `/dashboard`,
          // });
        }
      })
      .catch((error) => {
        //swalError(error?.message);
         setInitialLoading(false)
      });
  };
  const submitWidgetData = async () => {
    await fetchWrapper
      .post("dashboard/widget/save-user-widget", {
        module_id: 22,
        widgetData: widgetsData,
      })
      .then((response) => {
        if (!response?.error) {
          // swalSuccess(response?.message);
          // setCustomiseWidgets(false);
          history.push({
            pathname: `/`,
          });
          
        } else {
          // alert(error?.message)
          swalError(response?.error?.message);
        }
      })
      .catch((error) => {
        swalError(error?.message);
      });
  };

  const fetchWidget = async ()=>{
    setInitialLoading(true)

    if (customiseWidgets) {
      await getAllWidgetData();
    }
    else {
        await getAllgetSingleUserDataWidgetData();
    }
  }

  useEffect(() => {
    fetchWidget();
  }, [customiseWidgets]);
  return (
    <Spin spinning={initialLoading} style={{minHeight: '400px'}}>
      <DashboardUnit
      data={data}
      widgetsData={widgetsData}
      setWidgetsData={setWidgetsData}
      customiseWidgets={customiseWidgets}
      submitWidgetData={submitWidgetData}
      userDashboardData={userDashboardData}
      setCustomiseWidgets={setCustomiseWidgets}
      moduleInfo={22}
      initialLoading={initialLoading}
    />
    </Spin>
  );
};

export default Index;
